import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  constructor(private http: HttpClient) {}

  generateReport(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/reports/generate-test`, {
          responseType: 'blob',
          headers: { Accept: 'application/pdf' },
        })
        .subscribe({
          next: (response: any) => {
            this.downloadReport(response);
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  generateDamageReport(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/reports/generate-damage-report/${id}`, {
          responseType: 'blob',
          headers: { Accept: 'application/pdf' },
        })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  generateRentalReport(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/reports/generate-rental-report`, data, {
          responseType: 'blob',
          headers: { Accept: 'application/pdf' },
        })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  generateOutsourcedReport(data: any, flag: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${SETTINGS.BASE_API}/reports/generate-outsourced-report`,
          { data: data, flag: flag },
          {
            responseType: 'blob',
            headers: { Accept: 'application/pdf' },
          },
        )
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  generateInventoryReport(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/reports/generate-initial-report/${id}`, {
          responseType: 'blob',
          headers: { Accept: 'application/pdf' },
        })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  generateInventoryReportForThreeCompanies(id: any, data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${SETTINGS.BASE_API}/reports/generate-inventory-report/${id}`,
          data,
          {
            responseType: 'blob',
            headers: { Accept: 'application/pdf' },
          },
        )
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  generatePagingBoardReport(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/reports/paging-board`, data, {
          responseType: 'blob',
          headers: { Accept: 'application/pdf' },
        })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  generateRentalAgreementReport(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/reports/rental-agreement`, data, {
          responseType: 'blob',
          headers: { Accept: 'application/pdf' },
        })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  generatePaymentReceipt(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/reports/payment-receipt`, data, {
          responseType: 'blob',
          headers: { Accept: 'application/pdf' },
        })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  viewReport(data: Response | any): any {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url);
  }

  printReport(data: Response | any): any {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    document.body.appendChild(iframe);
    if (iframe.contentWindow) {
      iframe.contentWindow.print();
    }
  }

  downloadReport(data: Response | any): any {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'report.pdf'; // Set the desired file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
  emailPdf(): void {
    const email = 'recipient@gmail.com';
    const subject = 'Your email subject';
    const body = 'Your email body content';

    // Create the mailto link
    // Open the default email client (Gmail, if available)
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(body)}`;
  }
}
